module.exports = __webpack_public_path__ + "img/1.1.25a3a023.png";